const slideshow = {

    elements: {},

    playState: 'playing',

    resizeCaptions() {
        const $captions = this.elements.$slideshowContainer.find('.slideshow__caption');
        let height = 0;
        $captions.each(function(){
            const captionHeight = jQuery(this).height('auto').height();
            height = Math.max( captionHeight, height );
        });
        $captions.height(height);
    },

    cacheDom() 
    {
        this.elements.$slideshowContainer = jQuery('.js-slideshow');
        this.elements.$slideshow = this.elements.$slideshowContainer.find('.js-slideshow-root');
        this.elements.$progressBar = this.elements.$slideshow.find('.js-progress-bar');
        this.elements.$indicator = this.elements.$slideshow.find('.js-indicator');
    },

    bind()
    {
        this.elements.$slideshow.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
            if( this.playState === 'playing')
            {
                this.elements.$indicator.removeClass('slideshow__indicator--running');
                this.elements.$slideshowContainer.removeClass('is-paused');
            }
        });

        this.elements.$slideshow.on('afterChange', (event, slick, currentSlide, nextSlide) => {
            // $slideshow.find('.scale-in-full').removeClass('scale-in-full--active');

            // const $currentSlide = $slideshow.find('.slick-current');
            // $currentSlide.find('.scale-in-full').addClass('scale-in-full--active');
            if( this.playState === 'playing')
            {
                this.elements.$indicator.removeClass('slideshow__indicator--running');
                this.elements.$slideshowContainer.removeClass('is-paused');
            }            
            // add a slight delay before restoring the classname, to ensure it's been removed
            setTimeout( () => {this.elements.$indicator.addClass('slideshow__indicator--running');}, 10 );
            
        });

        this.elements.$slideshow.on('init', () => {
            this.elements.$slideshowContainer.addClass('slideshow--ready');
            this.elements.$indicator.addClass('slideshow__indicator--running');
            this.resizeCaptions();

            window.addEventListener('resize', () => {
                this.resizeCaptions();
            });

        });

        const element = this.elements.$slideshowContainer.get(0);

        const runOnReveal = () => {
            const elementRect = element.getBoundingClientRect();
            const height = parseInt(element.offsetHeight);
            const top = elementRect.top;

            if( top - height < 0 )
            {
                this.run();
                window.removeEventListener('scroll', runOnReveal);
            }
        }

        window.addEventListener('scroll', runOnReveal);

        runOnReveal();

        element.addEventListener('click', e => {
                    
            if( e.target.classList.contains('js-slideshow-next') ) {
                this.elements.$slideshow.slick("slickNext");
            } else if ( e.target.classList.contains('js-slideshow-prev') ) {
                this.elements.$slideshow.slick("slickPrev");
            } else if ( e.target.classList.contains('js-slideshow-playstate') ) {
                if( this.playState === 'playing')
                {
                    this.elements.$slideshow.slick("slickPause");
                    this.playState = 'paused';
                    e.target.classList.add('directional-nav__playstate--paused');
                    e.target.querySelector('span').innerText = 'Play';
                    this.elements.$indicator.removeClass('slideshow__indicator--running');
                    this.elements.$indicator.addClass('slideshow__indicator--paused');
                    this.elements.$slideshowContainer.addClass('is-paused');
                }
                else
                {
                    this.elements.$slideshow.slick("slickPlay");
                    this.playState = 'playing';
                    e.target.classList.remove('directional-nav__playstate--paused');
                    e.target.querySelector('span').innerText = 'Pause';
                    this.elements.$indicator.removeClass('slideshow__indicator--paused');
                    this.elements.$slideshowContainer.removeClass('is-paused');
                }
            }
        });
    },

    run() 
    {
        this.elements.$slideshow.slick({
            //arrows: false,
            //useCss: false,
            //cssTransitions: false,
            //speed: 0,

            fade: true,
            dots: false,
            infinite: true,
            slide: '.slide',
            autoplay: true,
            autoplaySpeed: 5000,
            pauseOnHover: false,
            nextArrow: '.js-slideshow-next',
            prevArrow: '.js-slideshow-prev'
        });
    },

    init() {
        this.cacheDom();

        if( this.elements.$slideshowContainer.length )
        {
            this.bind();
        }
    }
}

export default slideshow;